import { stageAddressLifeCycleTypes } from './addressLifeCycle';

export const houseStatus = {
  construction: 'construction',
  acceptance: 'acceptance',
  handedOver: 'handedOver',
};

export const requestInFlatStatuses = {
  immediate: 'immediate',
  debt: 'debt',
  active: 'active',
  comment: 'comment',
};

export const acceptanceResultsStatuses = {
  notAccepted: 1,
  acceptedWithComments: 2,
  accepted: 3,
};

export const initActiveEntranceName = 'Все';

export const REMOVED_METER_ID = 5;
export const HOUSE_ACCEPTANCE_STAGE_ID = 6;

const key = stageAddressLifeCycleTypes.ACCEPTANCE;
export const flatStatusToAcceptanceResult = new Map([[key, [1, 2, 3]]]);

export const docEntities = {
  house: 'house',
  room: 'room',
};

export const flatMeterNoDataId = 4;
export const defaultFlatMeterTariffCount = 1;

export const flatTypes = {
  flat: 3,
  office: 7,
};
